import React, { FC } from 'react';
import styled from 'styled-components';
import { Text } from '@starrez/starryui9';
import { color } from '@starrez/starryui9';
import { Highlighted } from '@starrez/starryui';
import { useSelectionOption } from './Context';

type variant = 'control' | 'icon';

interface IOptionCheckboxProps {
    caption: string;
    checked?: boolean;
    highlight?: string;
    onClick: () => void;
    variant?: variant;
    closeOnClick?: boolean;
}

export const OptionCheckbox: FC<IOptionCheckboxProps> = ({ highlight, checked, caption, onClick, variant = 'icon' }) => {
    const { onItemClick } = useSelectionOption();

    const handleOnClick = () => {
        onItemClick({ name: 'OptionCheckbox', value: checked });
        onClick();
    };

    return (
        <li>
            <StyledButton variant={variant} aria-pressed={checked} onClick={handleOnClick} type="button">
                {variant === 'control' && <input readOnly type="checkbox" checked={checked} />}

                <Text color={color.Grey.G80} variant="normal.regular">
                    <Highlighted Highlight={highlight} Text={caption} />
                </Text>

                {checked && variant === 'icon' && (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.2929 8.29289C15.6834 7.90237 16.3166 7.90237 16.7071 8.29289C17.0976 8.68342 17.0976 9.31658 16.7071 9.70711L11.2071 15.2071C10.8166 15.5976 10.1834 15.5976 9.79289 15.2071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L10.5 13.0858L15.2929 8.29289Z"
                            fill={color.Blue.B60}
                        />
                    </svg>
                )}
            </StyledButton>
        </li>
    );
};

const StyledButton = styled.button<{ variant?: variant }>`
    min-height: 40px;
    margin: 0;
    width: 100%;
    text-align: left;
    background: none;
    padding: 0 16px;
    padding-right: 8px;
    display: grid;
    grid-template-columns: ${(props) => (props.variant === 'icon' ? 'auto 30px' : '30px auto')};
    align-items: center;
    cursor: pointer !important;
    border-radius: 4px;
    border: 2px solid transparent;

    > * {
        cursor: pointer !important;
    }

    &:focus {
        outline: none;
        border-color: ${color.Blue.B80};
    }

    &:hover {
        border-radius: 0;
        background: ${color.Grey.G10};
    }
`;
